module.exports = __webpack_public_path__ + "static/media/umich_logo.307d8f0d.png";